import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import type { UniformTypes } from "~enums/uniformTypes.ts";
import { useApi } from "../../../shared/api";

const DefaultUniformLimit = 1000; // We do not expect more items here. For tabs component especially.

export const useFetchUniforms = (baseType: UniformTypes, baseId: string) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();

  const fn = async () => {
    const response = await fetchData({
      url: `${sport}/o/${organizationId}/uniforms?baseType=${baseType}&baseId=${baseId}&sortBy=nameLocal&offset=0&limit=${DefaultUniformLimit}`,
    });
    return response.data || [];
  };

  return useQuery({
    queryKey: ["uniforms", sport, organizationId, baseType, baseId],
    queryFn: () => fn(),
  });
};
